import { createFileRoute } from '@tanstack/react-router';

import { adsTxtDomainsRouteSearchSchema } from '../features/supply/adsTxt/adsTxtDomainsRouteSearch';
import { AdsTxtDomainsTable } from '../features/supply/adsTxt/components/AdsTxtDomainsTable';

export const Route = createFileRoute('/supply/ads-txt/domains')({
  validateSearch: adsTxtDomainsRouteSearchSchema,
  component: AdsTxtDomainsTable,
});
